/* eslint-disable no-shadow */
import React, { FunctionComponent } from 'react'
import { Artist } from 'Types/index'
import spotifyIcon from 'Shared/img/spotify-icon.png'

import { CheckArtistFromSearchProps } from './CheckArtistFromSearchProps'

import {
  SearchResults,
  SearchResultsItem,
  SearchResultsImg,
  SearchResultsText,
  SearchResultsTitle,
  SearchResultsDescription,
} from './styles'

const CheckArtistFromSearch: FunctionComponent<CheckArtistFromSearchProps> = ({
  onCheck,
  artists,
}) => {
  if (artists.length === 0) return null

  const handleCheck = (item: Artist) => {
    onCheck({
      // @ts-ignore
      artistId: item.id,
      artistName: item.name,
      // @ts-ignore
      genres: item.genres,
    })
  }
  return (
    <SearchResults>
      {artists &&
        artists.map(item => (
          <SearchResultsItem
            key={item.id}
            onClick={() =>
              // @ts-ignore
              handleCheck(item)
            }
          >
            {item.images.length > 0 && item.images.length >= 3 ? (
              <SearchResultsImg
                src={item.images[2].url}
                alt={item.name}
                width="40"
              />
            ) : (
              <SearchResultsImg
                src={spotifyIcon}
                alt={spotifyIcon}
                width="40"
              />
            )}
            <SearchResultsText>
              <SearchResultsTitle>{item && item.name}</SearchResultsTitle>
              <SearchResultsDescription>
                {item.genres.length > 0 &&
                  item.genres.map((item, index, arr) => (
                    <span key={item}>
                      {index === 0
                        ? item.substr(0, 1).toUpperCase() +
                          item.substr(1).toLowerCase()
                        : item}
                      {index + 1 !== arr.length && ', '}
                    </span>
                  ))}
              </SearchResultsDescription>
            </SearchResultsText>
          </SearchResultsItem>
        ))}
    </SearchResults>
  )
}

export default CheckArtistFromSearch
